<template>
  <div
      class="fixed inset-0 -z-10 pointer-events-none overflow-hidden
        bg-[linear-gradient(210deg,#0b0f08_0%,#040E09_60%,#040503_100%)]
        w-full h-full
        flex justify-center">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1600 900"
        preserveAspectRatio="xMidYMid slice"
        class="w-full min-h-[1000px]"
    >
      <defs>
        <!-- Prism face gradients using exact colors -->
        <linearGradient id="darkFacet" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#040E09"/>
          <stop offset="100%" style="stop-color:#091E12"/>
        </linearGradient>

        <linearGradient id="midFacet" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style="stop-color:#020604"/>
          <stop offset="100%" style="stop-color:#26341C"/>
        </linearGradient>

        <linearGradient id="goldFacet" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#E2B137;stop-opacity:0.4"/>
          <stop offset="100%" style="stop-color:#BF911C;stop-opacity:0.3"/>
        </linearGradient>
      </defs>

      <!-- Back layer - larger darker facets -->
      <polygon points="250,250 550,100 850,400" fill="url(#darkFacet)"/>
      <polygon points="850,400 1050,350 950,850" fill="url(#darkFacet)"/>
      <polygon points="550,100 900,150 1150,550" fill="url(#midFacet)"/>

      <!-- Mid layer - irregular shapes -->
      <polygon points="650,450 850,400 750,600" fill="url(#midFacet)"/>
      <polygon points="900,150 1100,250 1050,350" fill="url(#darkFacet)"/>

      <!-- Golden accent facets - asymmetric placement -->
      <polygon points="750,350 900,320 850,450" fill="url(#goldFacet)">
        <animate attributeName="opacity" values="0.8;0.5;0.8" dur="6s" repeatCount="indefinite"/>
      </polygon>

      <polygon points="800,480 920,440 880,580" fill="url(#goldFacet)">
        <animate attributeName="opacity" values="0.5;0.8;0.5" dur="7s" repeatCount="indefinite"/>
      </polygon>

      <polygon points="950,280 1020,300 980,380" fill="url(#goldFacet)" opacity="0.5">
        <animate attributeName="opacity" values="0.5;0.8;0.5" dur="8s" repeatCount="indefinite"/>
      </polygon>
    </svg>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped></style>
